import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MatchModal } from "../../components";
import { CircularProgress } from "@material-ui/core";
import EntityMapDialog from "../../components/EntityMapDialog";
import Cluster from "./Cluster";
import VisibilitySensor from "react-visibility-sensor";
import CloseIcon from "@material-ui/icons/Close";
import TextTooltip from "../IntentClassification/Tooltip";
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Alert from '@material-ui/lab/Alert';
import { pushMessage, removeMessage } from "../../../../redux/actions/commonActions";


// Library
import _ from "lodash";

// Material helpers
import Typography from "@material-ui/core/Typography";
import {
  Box,
  withStyles,
  Dialog,
  DialogTitle,
  IconButton,
  TextField,
  Button,
  DialogActions,
  DialogContent
} from "@material-ui/core";

// Style
import styles from "./styles";

const PLACEHOLDER_ID = "Utterance Placeholder";

class ClusterData extends React.Component {
  state = {
    selected: {},
    dialogOpened: false,
    modalVisible: [false, false],
    modalValues: [],
    modalIndex: null,
    targetCluster: "",
    data: [],
    newData: {},
    modalVisible: false,
    intent: "",
    tooltipVisible: false,
    tooltipCoordinates: {},
    activeUtterId: null,
    activeClusterId: null,
    dropdownIntents: null,
    groupByIntent: false,
    isLoading: false
  };

  isNotWhitespace(str) {
    return !(!str || /^\s*$/.test(str));
  }

  convertArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        ...obj,
        [item[key]]: item
      };
    }, initialValue);
  };

  extractEntities = text => {
    let entities = [];
    var newTxt = text.split("[");
    let idx = 0;
    for (var i = 1; i < newTxt.length; i++) {
      let startOffset = text.indexOf("[", idx);
      let word = newTxt[i].split(']')[0];
      text.slice(idx, startOffset);
      let entity = text.slice(text.indexOf("{", idx), text.indexOf("}", idx)+1);
      let ent = JSON.parse(entity);
      text = text.replace(`[${word}]${entity}`, word);
      idx = startOffset+word.length;
      if(this.isNotWhitespace(text.charAt(startOffset-1)) || this.isNotWhitespace(text.charAt(startOffset+word.length)))continue;
      entities.push( {entity:ent.entity, value:word, start:startOffset, end:startOffset+word.length, role:ent.role?ent.role:null} ); 
    }
    return {
      text: text,
      entities: entities
    };
  };

  componentDidMount() {
    if(this.props.data){
      var selected = {};
      const newState = { ...this.state };
      let clusterKeys = Object.keys(this.props.data);
      let intents = this.props.dropdownIntents?[...this.props.dropdownIntents]:[];
      clusterKeys.forEach( cluster => {
        let cId = cluster;
        const newData = {};
        intents.forEach((item, index) => {
          if(!item.connection){
           intents[index].connection = "DefaultAction";
           intents[index].name = intents[index].name.replace("AMAZON.", "");
         }
          if(item.id === cluster){
            cId = item.name;
          }
        });
        selected[cId] = {};
        newData[cId] = this.props.data[cluster].map(initialUtterance => {
          let utterance = { ...initialUtterance };
          const uId = require("crypto")
            .createHash("md5")
            .update(utterance.user_input)
            .digest("hex");
          let entities = this.extractEntities(utterance.user_input);
          selected[cId][uId] = "0";
          utterance["id"] = uId;
          utterance["entities"] = entities.entities;
          utterance["user_input"] = entities.text;
          utterance["initialCluster"] = cId;
          return (utterance);
        })
        newState.newData[cId] = this.convertArrayToObject(newData[cId], "id");
      });
      newState.selected = selected;
      newState.newData[PLACEHOLDER_ID] = {};
      newState.selected[PLACEHOLDER_ID] = {};
      newState.targetCluster = this.props.groupByIntent?Object.keys(newState.newData).reverse()[1]:Object.keys(newState.newData)[0];
      newState.dropdownIntents = this.props.dropdownIntents;
      newState.groupByIntent = this.props.groupByIntent;
      this.setState(newState)}
  }

   //from JSON-a to log format
   convertFormat = (utter) => {
    let utterText = [];
    let idx = 0;
    utter.entities.forEach(item => {
      let part = "";
      utterText.push(utter.user_input.slice(idx, item.start));
      let word = utter.user_input.slice(item.start, item.end);
      if(item.role){
        part = `[${word}]{"entity":"${item.entity}", "role":"${item.role}"}`;
      }else{
        part = `[${word}]{"entity":"${item.entity}"}`;
      }
      utterText.push(part);
      idx = item.end;
    });
    utterText.push(utter.user_input.slice(idx));
    return utterText.join("");
  };

  generateFeedback = (clusterKey, utterKey) => {
    let feedback = [];
    const positiveCluster = this.state.newData[clusterKey];
    const utterance = positiveCluster[utterKey];
    const negativeCluster = this.state.newData[utterance.initialCluster];
    if(clusterKey !== PLACEHOLDER_ID){
      Object.keys(positiveCluster).forEach(uKey => {
        if(uKey === utterance.id)return;
        feedback.push({
          Id: utterance.id,
          Feedback: 1,
          UserInput: utterance.user_input,
          MatchedQuestion: positiveCluster[uKey].user_input,
          IntentId: "CLUSTERING"
        })
      })
    }
    Object.keys(negativeCluster).forEach(uKey => {
      feedback.push({
        Id: utterance.id,
        Feedback: 0,
        UserInput: utterance.user_input,
        MatchedQuestion: negativeCluster[uKey].user_input,
        IntentId: "CLUSTERING"
      })
    })
    return feedback; 
  }

  saveClusterFeedback = () => {
    let feedback = [];
    let data = {...this.state.newData};
    Object.keys(data).forEach(clusterKey => {
      Object.keys(data[clusterKey]).forEach(utterKey => {
        if(data[clusterKey][utterKey].initialCluster != clusterKey){
          if(this.state.groupByIntent){
            let clusterKeyCopy = clusterKey;
            if (clusterKey === PLACEHOLDER_ID) return;
            let utterance = data[clusterKey][utterKey];
            this.state.dropdownIntents.forEach(item => {
              if (item.name === clusterKey) {
                clusterKeyCopy = item.id;
              }
            });
            feedback.push({
              Id: utterKey,
              Feedback: null,
              UserInput: utterance.user_input,
              IntentId: clusterKeyCopy,
              Utterance: this.convertFormat(utterance)
            });
          } else {
            feedback.push(this.generateFeedback(clusterKey, utterKey));
            feedback = feedback.flat(1);
          }
        }
      })})
    if(feedback.length>0){
      this.props.saveFeedback(feedback, true);
    }else{
      let msg = this.state.groupByIntent?"Please switch utterances between intents to successfully train data!":"Please switch utterances between clusters to successfully train data!";
      this.props.pushMessage({
        message: msg,
        type: "warning"
      });
    }
  }


  mapToQuestionDialog = (clusterKey, e) => {
    e.preventDefault();
    const newState = { ...this.state };
    newState.dialogOpened = true;
    newState.modalValues = []; //newState.selected[clusterKey];
    newState.modalIndex = clusterKey;
    const data = this.state.newData[clusterKey];
    Object.entries(data).forEach(([uttKey, utterance]) => {
      if (newState.selected[clusterKey][uttKey] == "1") {
        newState.modalValues.push(utterance["user_input"]);
      }
    });
    this.setState(newState);
  };
  async saveUtteranceFeedback(feedback) {
    await this.props.saveFeedback(feedback);
  }

  closeMapToQuestionDialog = selectedQuestion => {
    const newState = { ...this.state };
    if (selectedQuestion) {
      var feedback = [];
      const data = this.state.newData[newState.modalIndex];
      _.forEach(data, (utterance, index) => {
        let value = newState.selected[newState.modalIndex][utterance.id];
        feedback.push({
          UserInput: utterance["user_input"],
          MatchedQuestion: selectedQuestion,
          Feedback: value
        });
      });
      this.saveUtteranceFeedback(feedback);
    }
    newState.dialogOpened = false;
    newState.modalValue = [];
    newState.modalIndex = null;
    this.setState(newState);
  };

  handleRadioChange = (clusterKey, utteranceKey, val) => {
    const oldArray = { ...this.state.selected[clusterKey] };
    oldArray[utteranceKey] = val;
    const newState = { ...this.state.selected };
    newState[clusterKey] = oldArray;
    this.setState({ selected: newState });
  };

  sellectAll = (clusterKey, e) => {
    const oldArray = { ...this.state.selected[clusterKey] };
    const action = e.target.checked ? "1" : "0";
    Object.keys(oldArray).forEach(key => {
      oldArray[key] = action;
    });
    const newState = { ...this.state.selected };
    newState[clusterKey] = oldArray;
    this.setState({ selected: newState });
  };

  handleUtteranceSwitch = (clusterKey, id) => {
    const { newData, selected, targetCluster } = this.state;
    let sourceKey, destinationKey;
    if(clusterKey === PLACEHOLDER_ID){
      sourceKey = PLACEHOLDER_ID;
      destinationKey = targetCluster;
    }else{
      sourceKey = clusterKey;
      destinationKey = PLACEHOLDER_ID;
    }

    const sourceArray = { ...newData[sourceKey] };
    const destinationArray = { ...newData[destinationKey] };
    destinationArray[id] = sourceArray[id];
    delete sourceArray[id];
    var newState = { ...newData };
    newState[destinationKey] = destinationArray;
    newState[sourceKey] = sourceArray;
    const oldSelected = { ...selected[sourceKey] };
    const newSelected = { ...selected[destinationKey] };
    newSelected[id] = oldSelected[id];
    delete oldSelected[id];
    var newStateSelected = { ...selected };
    newStateSelected[destinationKey] = newSelected;
    newStateSelected[sourceKey] = oldSelected;
    this.setState({
      newData: newState,
      selected: newStateSelected
    });
  };

  setVisible = (isVisible, key) => {
    if (isVisible) {
      this.setState({ targetCluster: key });
    }
  }

  loadEntities = async () => {
    await this.props.fetchDropdownEntities();
    this.setState({ isLoading: false});
  } 

  openModal = (cId, type) => {
    if (type === "int") {
      this.setState({
        modalVisible: [false, true],
        tooltipVisible: false,
        selectedValue: cId,
        activeClusterId: cId,
      })
    }else{
      this.setState({
        modalVisible: [true, false], 
        tooltipVisible: false,
        isLoading: true,
        selectedValue: null
      })
      this.loadEntities();
    }
  };

  closeModal = () => {
    this.setState({
      modalVisible: [false, false]
    });
  };

  closeTooltip = () => {
    this.setState({
      tooltipVisible: false
    })
  }

  
  loadEntities = async () => {
    await this.props.fetchDropdownEntities();
    this.setState({ isLoading: false});
  } 

  insertEntity = (entities, sIdx, fIdx, role, value) => {
    let offsets = this.state.selectedOffset;
    entities.splice(sIdx, fIdx,
     {entity: value.name,
      role: role,
      start: offsets.startOffset,
      end: offsets.endOffset,
      value: this.state.selectedText});
  }

  handleEntityMap = (selectedValue, selectedRole) => {
    if(!selectedValue)return;
    let offsets = this.state.selectedOffset;
    let utt = {...this.state.newData}; 
    let item = {...utt[this.state.activeClusterId][this.state.activeUtterId]};
    let entities = [...item.entities];
    let entNum = entities.length;
    if(entNum>0){
      for(let i = 0;i<entNum;i++){
       if(entities[i].start > offsets.endOffset){
        this.insertEntity(entities,i,0, selectedRole, selectedValue);
        break;
       }else if(entities[i].end > offsets.startOffset){
        this.insertEntity(entities,i,1, selectedRole, selectedValue);
        break;
       }else if(entNum-1 === i){
        this.insertEntity(entities,entNum,0, selectedRole, selectedValue);
        break;}}
    }else{
      this.insertEntity(entities,0,0, selectedRole, selectedValue);
    }
    //ubaci u DB ako je novi entity/role
    if((selectedRole && !selectedValue.role.includes(selectedRole)) || 
    !this.props.dropdownEntities.includes(selectedValue)){
        this.props.saveEntityType(selectedValue, selectedRole);
    }
    item.entities = entities;
    utt[this.state.activeClusterId][this.state.activeUtterId] = item;
    this.setState({
      selectedValue: null,
      utterances: utt
    })
    this.closeModal();
  }


  handleIntentMap = () => {
    const { newData, selected, activeClusterId, selectedValue } = this.state;
    if (
      activeClusterId === selectedValue ||
      selectedValue.name === undefined ||
      activeClusterId === selectedValue.name
    ) {
      this.closeModal();
      return;}
    let newState = {...newData};
    let newStateSelected = {...selected};
    let desUtter = {...newState[selectedValue.name]};
    let srcUtter = {...newState[activeClusterId]};
    let desSel = {...newStateSelected[selectedValue.name]};
    let srcSel = {...newStateSelected[activeClusterId]};

    Object.keys(srcSel).forEach((key) => {
      if(srcSel[key] === "1"){
        desUtter[key] = srcUtter[key];
        delete srcUtter[key];
        desSel[key] = srcSel[key];
        delete srcSel[key];
      }
    });

    newStateSelected[selectedValue.name] = desSel;
    newStateSelected[activeClusterId] = srcSel;
    newState[selectedValue.name] = desUtter;
    newState[activeClusterId] = srcUtter;

    this.setState({
      newData: newState,
      selected: newStateSelected
    });  
    this.closeModal();
  };

  getSelected = (utterId, clusterId) => {
    let selectedBlock = window.getSelection();
    let selectedTxt = selectedBlock.toString();
    let range = selectedBlock.getRangeAt(0);
    let commonContainer = range.commonAncestorContainer.nodeName;
    if(!this.isNotWhitespace(selectedTxt) || 
    ["DIV","UL"].indexOf(commonContainer) > -1 ||
    range.cloneContents().querySelectorAll(".entity").length>1 ||
    !this.state.groupByIntent)return;
    var startNode = range.startContainer.parentNode;
    let startOffset = range.startOffset;
    for (;;) {
      if (startNode.previousSibling === null) break;
      let previousNode = startNode.previousSibling;
      startOffset += previousNode.textContent.length;
      startNode = previousNode; 
    }
    if (selectedTxt[0] === " ") startOffset += 1;
    selectedTxt = selectedTxt.trim();
    let endOffset = startOffset + selectedTxt.length;
    let rect = range.getBoundingClientRect();
    this.setState({
      tooltipVisible: true,
      tooltipCoordinates: { left: rect.left, top: rect.top + window.scrollY, width: rect.width },
      selectedText: selectedTxt,
      selectedOffset: { startOffset: startOffset, endOffset: endOffset },
      activeUtterId: utterId,
      activeClusterId: clusterId
    }) 
  } 


  render() {
    /* const filter = createFilterOptions(); */ 
    const { classes, overflowMessage, utteranceCount} = this.props;
    const { modalValues, dialogOpened, selected, newData, dropdownIntents, groupByIntent } = this.state;
    if (newData === null || Object.keys(newData).length === 0) {
     if(overflowMessage){
       return <Alert severity="info"><Typography color="primary" variant="h6">
                  {overflowMessage} {utteranceCount?`(${utteranceCount} Utterances) Please reduce the time range and try again!`:null}
              </Typography></Alert>
     }
      return <Alert severity="info"><Typography color="primary" variant="h6">
          No results found for your specified criteria. Please change your search filter parameters.
      </Typography></Alert>
    }

    let clusterData = Object.keys(newData).filter(e => e !== PLACEHOLDER_ID);
    if(groupByIntent)clusterData.reverse();

    return (
      <React.Fragment>
        {this.state.tooltipVisible && (
          <TextTooltip
            closeTooltip={this.closeTooltip}
            openModal={this.openModal}
            index={this.state.activeIndex}
            text={"Set entity"}
            coordinates={this.state.tooltipCoordinates}
          />
        )}
        <Typography variant="h4" component="h4">
          Results:
        </Typography>
        <span className={classes.resultCount}>Total count: {this.props.utteranceCount} </span>
        <br /><br /><br /><br />
        <Box display="flex" justifyContent="space-between">
          <Box className={classes.clusterHolder}>
            {clusterData.map((clusterKey, index) => {
              let connector = "";
              if(dropdownIntents){dropdownIntents.some(item => {
                if(item.name===clusterKey){
                 connector = item.connection;
                 return true;}
              } )}
              return (
                <VisibilitySensor
                  key={clusterKey}
                  partialVisibility={true}
                  offset={{ bottom: window.innerHeight - 70 }}
                  onChange={isVisible => this.setVisible(isVisible, clusterKey)}
                >
                  <div
                    className={`${classes.cluster} ${
                      clusterKey == this.state.targetCluster ? classes.activeCluster : null
                    }`}
                  >
                    <Cluster
                      cluster={clusterKey}
                      connector={connector}
                      utterances={newData[clusterKey]}
                      selected={selected[clusterKey]}
                      selectAll={this.sellectAll}
                      handleRadioChange={this.handleRadioChange}
                      mapToQuestionDialog={this.mapToQuestionDialog}
                      handleUtteranceSwitch={this.handleUtteranceSwitch}
                      openModal={this.openModal}
                      textSelectHandler={this.getSelected}
                      activeCluster={this.state.activeClusterId}
                      groupByIntent={this.state.groupByIntent}
                    />
                  </div>
                </VisibilitySensor>
              );
            })}
          </Box>
          <Box className={classes.clustersPlaceholder}>
            <Cluster
              key={"clustersplaceholder"}
              cluster={PLACEHOLDER_ID}
              utterances={newData[PLACEHOLDER_ID]}
              selected={selected[PLACEHOLDER_ID]}
              selectAll={this.sellectAll}
              handleRadioChange={this.handleRadioChange}
              mapToQuestionDialog={this.mapToQuestionDialog}
              handleUtteranceSwitch={this.handleUtteranceSwitch}
              openModal={this.openModal}
              textSelectHandler={this.getSelected}
              activeCluster={this.state.activeClusterId}
              groupByIntent={this.state.groupByIntent}
              saveClusterFeedback={this.saveClusterFeedback}
            />
          </Box>
        </Box>

        {this.state.modalVisible[0]&&
        <EntityMapDialog 
          selectedText={this.state.selectedText}
          closeModal={this.closeModal}
          show={this.state.modalVisible[0]}
          handleEntityMap={this.handleEntityMap}
          isLoading={this.state.isLoading}
        />}

        <Dialog open={this.state.modalVisible[1]}>
          <DialogTitle disableTypography className={classes.modalTitle}>
            <Typography variant="h5">
              Set intent
            </Typography>
             {this.closeModal ? (
               <IconButton aria-label="close" className={classes.closeButton} onClick={this.closeModal}>
                 <CloseIcon />
               </IconButton>
             ) : null}
          </DialogTitle>
          <DialogContent dividers>
          <Autocomplete
            classes={{
                groupLabel: classes.groupLabel,
            }}
            groupBy={(option) => option.connection}
            renderOption={(option) => {return option.name;}}
            onChange={(event, newVal) => {
              if( typeof newVal === 'string'){
                this.setState({
                  selectedValue:newVal
                })
              }else if (newVal && newVal.inputValue){
                this.setState({
                  selectedValue:{name:newVal.inputValue}
                })
              }else {
                this.setState({
                  selectedValue:newVal
              })}
            }}
            options={ dropdownIntents?[...dropdownIntents].sort((a,b) => -b.connection.localeCompare(a.connection)):[]}
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return option;
              }
              else if (option.inputValue) {
                return option.inputValue;
              }else if(option.name && !option.connection){
              return option.name;
              }
              return option.name + "[" + option.connection + "]";
              }}
            style={{ width: 350 }}
            renderInput={(params) => <TextField {...params} label="Start typing to filter" variant="outlined" />}
            /> 

            {/*
            DODATI U AUTOCOMPLETE ZA DODAVANJE NOVOG INTENA:
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            freeSolo
            value={this.state.selectedValue}
            filterOptions={(options, params) => {
            const filtered = filter(options, params);
              if (params.inputValue !== '') {
                filtered.push({
                  	inputValue: params.inputValue,
                    name: `Set "${params.inputValue}" as intent`
                });
                }
              return filtered;
              }} */}
              
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleIntentMap} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {dialogOpened && (
          <MatchModal data={modalValues} open={dialogOpened} cluster parentCloseFunc={this.closeMapToQuestionDialog} />
        )}
      </React.Fragment>
    );
  }
}

ClusterData.propTypes = {};

function mapStateToProps(state) {
  return {
    utterancesError: state.utterance.code,
    utteranceCount: state.utterance.count,
    overflowMessage: state.utterance.msg,
    dropdownEntities: !_.isEmpty(state.utterance.dropdownEntities) ? state.utterance.dropdownEntities : null, 
    dropdownIntents: !_.isEmpty(state.utterance.dropdownIntents) ? state.utterance.dropdownIntents : null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      pushMessage,
      removeMessage,
    }, dispatch),
    dispatch
  };
}

ClusterData = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClusterData);

export default withStyles(styles)(ClusterData);
